/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
 */

import pluginFactory from 'taoTests/runner/plugin';

const defaultConfig = {
    qtiItemContainerSelector: '.qti-item'
};
/**
 * This plugin scales the item to fit the container
 */
export default pluginFactory({
    name: 'customUIStyles',

    install() {
        const providedConfig = this.getTestRunner().getPluginConfig(this.getName()) || {};
        const pluginConfig = { ...defaultConfig, ...providedConfig };
        this.setConfig(pluginConfig);
    },

    init() {
        const testRunner = this.getTestRunner();
        const areaBroker = testRunner.getAreaBroker();
        const config = testRunner.getConfig();
        const customUiId = config && config.options && config.options.customUiId;
        //for each item add the identifier to container and custom ui classes
        testRunner.on('renderitem', itemIdentifier => {
            const testRunnerArea = areaBroker.getTestRunnerArea();
            testRunnerArea.classList.add('custom-ui');
            testRunnerArea.classList.add(customUiId);
            const itemContainer = areaBroker.getContentArea().querySelector(this.getConfig().qtiItemContainerSelector);
            itemContainer.dataset['itemIdentifier'] = itemIdentifier;
            itemContainer.firstElementChild?.classList.add(customUiId);
        });
    },

    /**
     * add styles to document head
     */
    render() {
        const config = this.getTestRunner().getConfig();
        const customUiId = config && config.options && config.options.customUiId;
        const pluginConfig = this.getConfig();
        const customStyles = pluginConfig[customUiId];

        //add styles directly to document's head;
        this.styleTag = document.createElement('style');
        this.styleTag.innerHTML = customStyles;
        document.head.appendChild(this.styleTag);
    },

    /**
     * Destroys the plugin
     */
    destroy() {
        if (this.styleTag) {
            this.styleTag.remove();
        }
    }
});
